// extracted by mini-css-extract-plugin
module.exports = {"customList":"_2YfYwFGK-4F2GGM87RNQFh","policyListContainer":"Q1lmy4jAIsj-ALXnelmAn"};